import * as React from 'react'
import { Rectangle } from 'recharts'

import { BAR_WIDTH, BarType } from './constants'

export function InsiderVolumeBar({ x, width, ...props }: any) {
  let newX = x
  const value = props.payload[props.dataKey]
  const isCenteredBar = props.payload.saleAggregated === 0 || props.payload.buyAggregated === 0
  if (isCenteredBar) {
    if (props.name === BarType.Sale) newX += width / 2
    else newX -= width / 2
  }

  if (value === 0 || !Number.isFinite(value)) {
    // Needs to return an element, so return an empty node
    return <React.Fragment />
  }

  return (
    <g>
      <Rectangle
        x={isCenteredBar ? newX - width / 2 : x}
        y={props.background.y}
        width={isCenteredBar ? width * 2 : width}
        height={props.background.height}
        fill="transparent"
      />
      {props.name === BarType.Sale && (
        <Rectangle
          {...props}
          x={isCenteredBar ? newX + width / 2 - BAR_WIDTH / 2 : newX + width - BAR_WIDTH}
          width={BAR_WIDTH}
        />
      )}
      {props.name === BarType.Buy && (
        <Rectangle {...props} x={isCenteredBar ? x - BAR_WIDTH / 2 : newX} width={BAR_WIDTH} />
      )}
    </g>
  )
}
